import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from "@mui/material";

function QuickWordPublishDialog({
  open,
  onClose,
  selectedCommand,
  onPublish,
  isProcessing,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Publish Command</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to publish the command &quot;
          {selectedCommand?.id}&quot;? This will make it available in
          production.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onPublish}
          color="primary"
          variant="contained"
          disabled={isProcessing === "publish"}
        >
          Publish
          {isProcessing === "publish" && (
            <CircularProgress size={20} sx={{ ml: 1 }} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default QuickWordPublishDialog;
